import axios from "axios";

export const requestERPLYData = (requestData, withCredentials) => {
  const requestFormData = new FormData();
  Object.entries(requestData).forEach((fieldValue) => {
    const [key, value] = fieldValue;
    requestFormData.set(`${key}`, `${value}`);
  });
  const options = {
    method: "post",
    headers: { "Content-type": "multipart/form-data" },
    url: `https://${requestData.clientCode}.erply.com/api/`,
    data: requestFormData,
    withCredentials: true,
  };
  return axios(options);
};
